module.exports = __webpack_public_path__ + "img/4.e2226768.jpg";